import { defineSchoolFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const schoolDescriptor = defineSchoolFilter({
  definition: {
    id: FilterId.SCHOOL,
    name: 'School',
    type: FilterType.SCHOOL,
    schoolResultItems: {},
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_SCHOOL },
});
